var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8404 8.36121C11.689 8.36121 11.5362 8.35046 11.3834 8.32898C11.1099 8.29041 10.9195 8.03748 10.9581 7.76404C10.9966 7.4906 11.2496 7.29822 11.523 7.33875C12.2139 7.43396 12.8902 7.20984 13.3824 6.71814L14.5245 5.57605C15.3795 4.72107 15.3795 3.33044 14.5245 2.47546C13.67 1.62097 12.2784 1.62097 11.4239 2.47546L10.2818 3.61755C9.78962 4.10974 9.56354 4.78796 9.66169 5.47791C9.70026 5.75134 9.51032 6.00427 9.23688 6.04333C8.96198 6.08142 8.71051 5.89148 8.67145 5.61853C8.52839 4.61462 8.85798 3.62732 9.57477 2.91052L10.7169 1.76843C11.962 0.523315 13.9864 0.523315 15.2315 1.76843C15.8345 2.37146 16.1666 3.17273 16.1666 4.02576C16.1666 4.87878 15.8345 5.68005 15.2315 6.28308L14.0894 7.42517C13.4825 8.0321 12.6817 8.36121 11.8404 8.36121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35876 14.832C4.54138 14.832 3.724 14.5209 3.10144 13.8984C1.85681 12.6537 1.85681 10.6284 3.10144 9.38372L4.24353 8.24163C4.95984 7.52533 5.94714 7.1972 6.95056 7.33783C7.224 7.3764 7.41443 7.62933 7.37585 7.90277C7.33728 8.17621 7.08582 8.36761 6.81091 8.32806C6.11755 8.23187 5.44226 8.45648 4.95056 8.94867L3.80847 10.0908C2.95349 10.9457 2.95349 12.3364 3.80847 13.1913C4.66296 14.0458 6.05457 14.0458 6.90906 13.1913L8.05115 12.0493C8.53943 11.561 8.76599 10.8876 8.67322 10.2021C8.63611 9.92865 8.828 9.67669 9.10193 9.63958C9.37537 9.60199 9.62732 9.79486 9.66443 10.0683C9.79919 11.0659 9.46912 12.0453 8.75818 12.7563L7.61609 13.8984C6.99353 14.5209 6.17615 14.832 5.35876 14.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88184 10.618C6.75391 10.618 6.62598 10.5692 6.52832 10.4716C6.33301 10.2762 6.33301 9.95984 6.52832 9.76453L11.0977 5.19519C11.293 4.99988 11.6094 4.99988 11.8047 5.19519C12 5.3905 12 5.70691 11.8047 5.90222L7.23535 10.4716C7.1377 10.5692 7.00977 10.618 6.88184 10.618Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseIcon);
export default __webpack_public_path__ + "static/media/browse-icon.2ada96e01565ea58229a4b1be57af56e.svg";
export { ForwardRef as ReactComponent };